import { QrcodeOutlined } from '@ant-design/icons';
import { lazyRouteComponent } from '@tanstack/react-router';

import { Route } from '@lib/types/route';

import { ROUTE_PATHS } from '../route-paths';

export const getPublicRoutes = (): Route[] => [
  {
    path: ROUTE_PATHS.LOCAL_BUYER,
    page: lazyRouteComponent(() => import('./pages/buyer')),
    public: true,
    hidden: true,
    allowUnverified: true,
  },
];

export const getRoutes = (): Route[] => [
  {
    path: ROUTE_PATHS.LOCAL_OWNER,
    page: lazyRouteComponent(() => import('./pages/owner')),
    title: 'Nexo Local',
    icon: QrcodeOutlined,
  },
];
